import { render, staticRenderFns } from "./block-referrer.vue?vue&type=template&id=dbf6f670&scoped=true"
import script from "./block-referrer.vue?vue&type=script&lang=js"
export * from "./block-referrer.vue?vue&type=script&lang=js"
import style0 from "./block-referrer.vue?vue&type=style&index=0&id=dbf6f670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf6f670",
  null
  
)

export default component.exports